module.exports = __webpack_public_path__ + "static/img/2_2_1.c62b65fd.jpg";